import { getPaginated, getApi } from 'util/backendapi/fetch';
import {
  makeReportingDuck,
  ReportingDuckActions,
} from 'ducks/make-reporting-duck';

export const routeMarchObsPointListDuck = makeReportingDuck(
  'routeMarchObservationPoint',
  (filters) =>
    // Setting limit to 0 to disable pagination
    getPaginated('/reports/route-march-observation-points/', {
      ...filters,
      limit: 0,
    }),
  () => getApi('/reports/route-march-observation-points/info/')
);

export type RouteMarchObsPointListAction = ReportingDuckActions<
  typeof routeMarchObsPointListDuck
>;
